import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Main from '@/views/Main'

const routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    children: [
      // 发现
      {
        path: '/findList',
        name: 'findList',
        component: resolve => require(['../views/comprehensive/index.vue'], resolve),
      },
      // 数据中心
      {
        path: '/',
        name: 'dataCenter',
        component: resolve => require(['../views/dataCenter/index.vue'], resolve),
      },
      {
        path: '/dataCenterNew',
        name: 'dataCenterNew',
        component: resolve => require(['../views/dataCenter/indexNew.vue'], resolve),
      },
      // 充电安全
      {
        path: '/chargingSafety',
        name: 'chargingSafety',
        component: resolve => require(['../views/chargingSafety/index.vue'], resolve),
      },
      // 充电安全 重构新
      {
        path: '/chargingSafetyNew',
        name: 'chargingSafetyNew',
        component: resolve => require(['../views/chargingSafety/indexNew.vue'], resolve),
      },
      // 说明书
      {
        path: '/instruction',
        name: 'instruction',
        component: resolve => require(['../views/comprehensive/instruction/index.vue'], resolve),
      },
      // 说明书列表页面
      {
        path: '/detail',
        name: 'detail',
        component: resolve => require(['../views/comprehensive/instruction/detail.vue'], resolve),
      },
      // 常见问题、相关安装 信息详情
      {
        path: '/infoDetail',
        name: 'infoDetail',
        component: resolve => require(['../views/comprehensive/infoDetail.vue'], resolve),
      },
      // 常见问题
      {
        path: '/problem',
        name: 'problem',
        component: resolve => require(['../views/comprehensive/problem/index.vue'], resolve),
      },
      // 安装相关
      {
        path: '/installRelated',
        name: 'installRelated',
        component: resolve => require(['../views/comprehensive/relate/index.vue'], resolve),
      },
      // APP 使用
      {
        path: '/useInfo',
        name: 'useInfo',
        component: resolve => require(['../views/comprehensive/useInfo/index.vue'], resolve),
      },
      {
        path: '/bannerUrl',
        name: 'bannerUrl',
        component: resolve => require(['../views/comprehensive/bannerUrl.vue'], resolve),
      },
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach((to, from, next) => {
  next()
})
export default router
